module.exports = __webpack_public_path__ + "img/pie-chart_light.22ba1c49.svg";